import { render, staticRenderFns } from "./ProjectApplicationProcessTwo.vue?vue&type=template&id=5c212b40&scoped=true&"
import script from "./ProjectApplicationProcessTwo.vue?vue&type=script&lang=js&"
export * from "./ProjectApplicationProcessTwo.vue?vue&type=script&lang=js&"
import style0 from "./ProjectApplicationProcessTwo.vue?vue&type=style&index=0&id=5c212b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c212b40",
  null
  
)

export default component.exports